'use client';

import { useEffect } from 'react';
import { Button } from '@heroui/react';
import { FaRotateRight } from 'react-icons/fa6';
import { captureBoundaryException } from '@/util/functions/observability/observability';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureBoundaryException(error, {
      surface: 'scheduler',
      ...(error.digest ? { digest: error.digest } : {}),
    });
  }, [error]);

  return (
    <div className='flex min-h-[600px] items-center justify-center p-8'>
      <div className='max-w-md text-center'>
        <div className='mb-6'>
          <div className='mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-red-100'>
            <FaRotateRight className='text-4xl text-red-600' />
          </div>
          <h2 className='mb-2 text-2xl font-bold text-gray-900'>
            We Had Trouble Loading Information
          </h2>
          <p className='text-gray-600'>
            Something went wrong while loading the scheduler. Please try
            refreshing the page.
          </p>
        </div>
        <Button
          onPress={reset}
          color='primary'
          size='lg'
          startContent={<FaRotateRight />}
        >
          Refresh
        </Button>
        {error.digest && (
          <p className='mt-4 text-xs text-gray-400'>Error ID: {error.digest}</p>
        )}
      </div>
    </div>
  );
}
